export const th = {
  "app.title": "survivrr.io",
  "menu.online": "ออนไลน์",
  "menu.offline": "ออฟไลน์",
  "menu.play": "เล่น",
  "menu.name": "ชื่อ",
  "menu.ballColor": "สีลูกบอล",
  "menu.nameColor": "สีชื่อ",
  "menu.moreInfo": "ข้อมูลเพิ่มเติม",
  "menu.moreInfoTitle": "ข้อมูลเพิ่มเติม",
  "menu.moreInfoSubtitle": "หน้ากฎหมาย รายละเอียดคุกกี้ และข้อมูลติดต่อ",
  "menu.back": "กลับ",
  "menu.privacySettings": "การตั้งค่าความเป็นส่วนตัว",
  "menu.cookiePolicy": "นโยบายคุกกี้",
  "menu.privacyPolicy": "นโยบายความเป็นส่วนตัว",
  "menu.termsOfService": "ข้อกำหนดการใช้บริการ",
  "menu.emailButton": "ส่งอีเมลถึงฉัน",
  "menu.websiteButton": "ดูเว็บไซต์ของฉัน",
  "menu.contactEmailLabel": "อีเมลติดต่อ:",
  "menu.emailLabel": "อีเมล:",
  "menu.websiteLabel": "ดูเว็บไซต์ของฉัน:",
  "menu.nameRequired": "กรุณาใส่ชื่อก่อน",
  "moreInfo.privacySettings.intro1": "คุณสามารถจัดการตัวเลือกความเป็นส่วนตัวบนเว็บไซต์นี้ผ่านข้อความขอความยินยอมที่แสดงโดยผู้ให้บริการโฆษณาของเราเมื่อมีให้ใช้งาน",
  "moreInfo.privacySettings.intro2": "คุณยังสามารถควบคุมคุกกี้และพื้นที่จัดเก็บในเครื่องได้ตลอดเวลาจากการตั้งค่าเบราว์เซอร์",
  "moreInfo.privacySettings.adsHeading": "การควบคุมโฆษณา",
  "moreInfo.privacySettings.adsParagraph": "โฆษณาบางรายการอาจมาจาก Google หรือพันธมิตรอื่น ๆ ตัวเลือกโฆษณาแบบปรับให้เหมาะกับคุณสามารถจัดการได้โดยตรงในการตั้งค่าโฆษณาของ Google",
  "moreInfo.privacySettings.adsBullet1": "เปิดการควบคุมโฆษณาของ Google ที่ myadcenter.google.com",
  "moreInfo.privacySettings.adsBullet2": "ล้างคุกกี้หรือข้อมูลเว็บไซต์หากต้องการรีเซ็ตตัวเลือกความยินยอม",
  "moreInfo.privacySettings.adsBullet3": "ใช้การตั้งค่าความเป็นส่วนตัวของเบราว์เซอร์เพื่อบล็อกหรือจำกัดคุกกี้",
  "moreInfo.privacySettings.localHeading": "การตั้งค่าในเครื่อง",
  "moreInfo.privacySettings.localParagraph": "เกมนี้บันทึกค่าพื้นฐานในเครื่อง เช่น ชื่อผู้เล่น สี การตั้งค่าเสียง และภาษา เพื่อให้เว็บไซต์จดจำบนอุปกรณ์ของคุณได้",
  "moreInfo.cookiePolicy.intro1": "เว็บไซต์นี้ใช้คุกกี้และเทคโนโลยีจัดเก็บข้อมูลที่คล้ายกันเพื่อให้เกมทำงาน จดจำการตั้งค่า และรองรับโฆษณา",
  "moreInfo.cookiePolicy.intro2": "คุกกี้อาจถูกใช้เพื่อการวัดผล ป้องกันการโกง และปรับแต่งโฆษณาตามตัวเลือกความยินยอมและบริการที่เปิดใช้งานบนเว็บไซต์",
  "moreInfo.cookiePolicy.typesHeading": "ประเภทคุกกี้และพื้นที่จัดเก็บที่เราอาจใช้",
  "moreInfo.cookiePolicy.typeBullet1": "พื้นที่จัดเก็บที่จำเป็นเพื่อให้เว็บไซต์ทำงาน",
  "moreInfo.cookiePolicy.typeBullet2": "พื้นที่จัดเก็บค่ากำหนดเพื่อจดจำชื่อ สี ภาษา และการตั้งค่าเสียง",
  "moreInfo.cookiePolicy.typeBullet3": "คุกกี้โฆษณาหรือการวัดผลที่ใช้โดยพันธมิตรโฆษณา เช่น Google เมื่อเปิดโฆษณา",
  "moreInfo.cookiePolicy.manageHeading": "วิธีจัดการคุกกี้",
  "moreInfo.cookiePolicy.manageParagraph": "คุณสามารถจัดการคุกกี้ผ่านข้อความขอความยินยอมบนเว็บไซต์เมื่อมีให้ใช้งาน หรือผ่านการตั้งค่าเบราว์เซอร์ การปิดคุกกี้บางรายการอาจส่งผลต่อฟีเจอร์ของเว็บไซต์หรือการแสดงโฆษณา",
  "moreInfo.privacyPolicy.intro1": "เว็บไซต์นี้เป็นเกมบนเบราว์เซอร์ที่ดำเนินการโดย Michał Kierzkowski เราพยายามเก็บข้อมูลส่วนบุคคลให้น้อยที่สุด",
  "moreInfo.privacyPolicy.intro2": "ไม่จำเป็นต้องมีบัญชีเพื่อเล่น เกมอาจบันทึกค่าพื้นฐานในเครื่องบนอุปกรณ์ของคุณและประมวลผลข้อมูลการเล่นที่จำเป็นสำหรับการแข่งขันออนไลน์",
  "moreInfo.privacyPolicy.infoHeading": "ข้อมูลที่เราอาจประมวลผล",
  "moreInfo.privacyPolicy.infoBullet1": "ชื่อผู้เล่นที่คุณเลือกและการตั้งค่ารูปลักษณ์",
  "moreInfo.privacyPolicy.infoBullet2": "ข้อมูลเซสชันพื้นฐานที่จำเป็นสำหรับฟีเจอร์ผู้เล่นหลายคน",
  "moreInfo.privacyPolicy.infoBullet3": "ข้อมูลอุปกรณ์ เบราว์เซอร์ หรือโฆษณาที่เก็บโดยพันธมิตรด้านวิเคราะห์หรือโฆษณาหากเปิดใช้งานบริการเหล่านั้น",
  "moreInfo.privacyPolicy.useHeading": "เราใช้ข้อมูลอย่างไร",
  "moreInfo.privacyPolicy.useBullet1": "เพื่อให้เกมและห้องออนไลน์ทำงาน",
  "moreInfo.privacyPolicy.useBullet2": "เพื่อจดจำการตั้งค่าบนอุปกรณ์ของคุณ",
  "moreInfo.privacyPolicy.useBullet3": "เพื่อปรับปรุงประสิทธิภาพ ความปลอดภัย และเสถียรภาพ",
  "moreInfo.privacyPolicy.useBullet4": "เพื่อแสดงโฆษณาเมื่อเปิดใช้งานโฆษณา",
  "moreInfo.privacyPolicy.contactHeading": "ติดต่อ",
  "moreInfo.privacyPolicy.contactParagraph1": "หากมีคำถามเกี่ยวกับความเป็นส่วนตัว ติดต่อ: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "เว็บไซต์: michalkierzkowski.com",
  "moreInfo.terms.intro1": "การใช้เว็บไซต์นี้หมายความว่าคุณตกลงที่จะใช้เกมอย่างถูกกฎหมายและเป็นธรรม",
  "moreInfo.terms.intro2": "เกมให้บริการตามสภาพที่เป็นอยู่ และอาจเปลี่ยนแปลง หยุดชะงัก หรือลบออกได้ทุกเมื่อ",
  "moreInfo.terms.rulesHeading": "กฎ",
  "moreInfo.terms.ruleBullet1": "อย่าใช้ประโยชน์จากบั๊ก สูตรโกง ระบบอัตโนมัติ หรือช่องโหว่",
  "moreInfo.terms.ruleBullet2": "อย่าพยายามทำอันตรายต่อบริการหรือผู้เล่นอื่น",
  "moreInfo.terms.ruleBullet3": "อย่าใช้ชื่อหรือเนื้อหาที่ไม่เหมาะสม ผิดกฎหมาย หรือทำให้เข้าใจผิด",
  "moreInfo.terms.limitationHeading": "ข้อจำกัด",
  "moreInfo.terms.limitationParagraph": "เราไม่รับผิดชอบต่อความสูญเสีย การหยุดชะงัก หรือความเสียหายจากการใช้เว็บไซต์ในขอบเขตสูงสุดที่กฎหมายอนุญาต",
  "moreInfo.terms.changesHeading": "การเปลี่ยนแปลง",
  "moreInfo.terms.changesParagraph": "ข้อกำหนดเหล่านี้อาจอัปเดตในอนาคต การใช้งานเว็บไซต์ต่อหลังอัปเดตหมายความว่าคุณยอมรับข้อกำหนดที่อัปเดตแล้ว",
  "status.offline": "กำลังเริ่มแมตช์ออฟไลน์...",
  "status.connecting": "กำลังเชื่อมต่อเซิร์ฟเวอร์...",
  "queue.title": "กำลังรอห้อง",
  "queue.menu": "กลับไปเมนูหลัก",
  "game.pressToMove": "กดที่ใดก็ได้เพื่อเคลื่อนที่",
  "game.touchToMove": "แตะที่ใดก็ได้เพื่อเคลื่อนที่",
  "game.leaderboard": "กระดานผู้นำ",
  "game.hp": "HP",
  "game.level": "เลเวล",
  "game.xp": "XP",
  "game.respawning": "กำลังเกิดใหม่...",
  "gameEnd.title": "จบเกม",
  "gameEnd.winTitle": "คุณชนะ",
  "gameEnd.subtitle": "แมตช์สิ้นสุดแล้ว เกิดใหม่เพื่อเริ่มรอบถัดไปหรือกลับไปเมนู",
  "pause.title": "เมนูเกม",
  "pause.resume": "เล่นต่อ",
  "pause.menu": "กลับไปเมนูหลัก",
  "upgrade.title": "เลือกอัปเกรด",
  "upgrade.generic.title": "อัปเกรด",
  "upgrade.generic.description": "พัฒนา build ของคุณ",
  "upgrade.newWeaponPrefix": "อาวุธใหม่:",
  "upgrade.stat.maxHp.title": "HP สูงสุด",
  "upgrade.stat.maxHp.description": "เพิ่ม HP สูงสุด",
  "upgrade.stat.speed.title": "ความเร็วเคลื่อนที่",
  "upgrade.stat.speed.description": "เพิ่มความเร็วเคลื่อนที่",
  "upgrade.stat.generic.title": "อัปเกรดค่าสถานะ",
  "upgrade.stat.generic.description": "พัฒนาค่าสถานะของคุณ",
  "upgrade.weapon.projectileShot.title": "ยิงโปรเจกไทล์",
  "upgrade.weapon.projectileShot.description": "เพิ่มการยิงโปรเจกไทล์ให้ build ของคุณ",
  "upgrade.weapon.orbitingBalls.title": "ลูกบอลโคจร",
  "upgrade.weapon.orbitingBalls.description": "เพิ่มลูกบอลโคจรให้ build ของคุณ",
  "upgrade.weapon.damageZone.title": "โซนความเสียหาย",
  "upgrade.weapon.damageZone.description": "เพิ่มโซนความเสียหายรอบตัวละคร",
  "upgrade.weapon.generic.title": "อาวุธ",
  "upgrade.weapon.generic.description": "เพิ่มอาวุธนี้ให้ build ของคุณ",
  "upgrade.weaponUpgrade.frequency.title": "ความถี่",
  "upgrade.weaponUpgrade.frequency.description": "โจมตีบ่อยขึ้น",
  "upgrade.weaponUpgrade.range.title": "ระยะ",
  "upgrade.weaponUpgrade.range.description": "เพิ่มระยะของอาวุธ",
  "upgrade.weaponUpgrade.projectileCount.title": "จำนวนโปรเจกไทล์",
  "upgrade.weaponUpgrade.projectileCount.description": "สร้างโปรเจกไทล์มากขึ้น",
  "upgrade.weaponUpgrade.projectileSpeed.title": "ความเร็วโปรเจกไทล์",
  "upgrade.weaponUpgrade.projectileSpeed.description": "ทำให้โปรเจกไทล์เร็วขึ้น",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "ความเร็วโคจร",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "ทำให้ลูกบอลโคจรหมุนเร็วขึ้น",
  "upgrade.weaponUpgrade.damage.title": "ความเสียหาย",
  "upgrade.weaponUpgrade.damage.description": "สร้างความเสียหายมากขึ้น",
  "upgrade.weaponUpgrade.generic.title": "อัปเกรดอาวุธ",
  "upgrade.weaponUpgrade.generic.description": "พัฒนาอาวุธนี้",
  "defeat.title": "แพ้",
  "defeat.subtitle": "เกิดใหม่หรือกลับไปเมนู",
  "defeat.respawn": "เกิดใหม่",
  "defeat.menu": "เมนูหลัก",
  "error.generic": "มีบางอย่างผิดพลาด",
} as const;
